/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Embed_Cv_Check_TitleInputs */

const en_admin_embed_cv_check_title = /** @type {(inputs: Admin_Embed_Cv_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV check`)
};

const de_admin_embed_cv_check_title = /** @type {(inputs: Admin_Embed_Cv_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-Check`)
};

/**
* | output |
* | --- |
* | "CV check" |
*
* @param {Admin_Embed_Cv_Check_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_embed_cv_check_title = /** @type {((inputs?: Admin_Embed_Cv_Check_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Embed_Cv_Check_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_embed_cv_check_title(inputs)
	return en_admin_embed_cv_check_title(inputs)
});